<pf-app-header
    [allowPasswordReset]="false"
    [logoLink]="['/queues']"
    [showMenuIcon]="false"
    [preLogoutAction]="preLogoutAction.bind(this)"
    #appHeader>
    <ng-template #warehouseDrawerContent let-drawerRef="drawerRef">
        <div class="warehouse-drawer">
            <pf-select
                label="Search warehouses"
                pfStyle="stacked"
                [control]="warehouseControl"
                [searchFacade]="warehouseFacade"
                [selectedOption]="selectedWarehouse"
                (selected)="selectWarehouse($event)"></pf-select>
        </div>
    </ng-template>

    <ng-template #userDrawerContent let-drawerRef="drawerRef">
        <div class="user-drawer">
            <div class="user-drawer__links">
                <!-- Documentation -->
                @if (isMobile) {
                    <button
                        type="button"
                        class="account-link"
                        (click)="openDocumentationEmbed(drawerRef)">
                        <pf-icon
                            class="account-link__icon"
                            iconType="documentation"></pf-icon>
                        <span class="account-link__text">
                            <span class="account-link__title"
                                >Documentation</span
                            >
                            <span class="account-link__desc">
                                Guides and how-tos for this screen
                            </span>
                        </span>
                    </button>
                } @else {
                    <a
                        class="account-link"
                        [href]="documentationUrl"
                        target="_blank"
                        rel="noopener noreferrer"
                        (click)="drawerRef.close()">
                        <pf-icon
                            class="account-link__icon"
                            iconType="documentation"></pf-icon>
                        <span class="account-link__text">
                            <span class="account-link__title"
                                >Documentation</span
                            >
                            <span class="account-link__desc">
                                Guides and how-tos for this screen
                            </span>
                        </span>
                    </a>
                }

                <!-- Need help? -->
                @if (isMobile) {
                    <button
                        type="button"
                        class="account-link"
                        (click)="showHelpModal(drawerRef)">
                        <pf-icon
                            class="account-link__icon"
                            iconType="helpChat"></pf-icon>
                        <span class="account-link__text">
                            <span class="account-link__title">Need help?</span>
                            <span class="account-link__desc">
                                Contact Control Tower support
                            </span>
                        </span>
                    </button>
                } @else {
                    <a
                        class="account-link"
                        [href]="supportMailtoLink"
                        (click)="drawerRef.close()">
                        <pf-icon
                            class="account-link__icon"
                            iconType="helpChat"></pf-icon>
                        <span class="account-link__text">
                            <span class="account-link__title">Need help?</span>
                            <span class="account-link__desc">
                                Contact Control Tower support
                            </span>
                        </span>
                    </a>
                }
            </div>

            <button
                type="button"
                class="account-logout"
                (click)="logout(drawerRef)">
                Logout
            </button>
        </div>
    </ng-template>

    <ng-template #documentationEmbedContent>
        <iframe
            title="Documentation"
            [src]="embedSafeUrl"
            class="documentation-embed"
            frameborder="0"
            allowfullscreen></iframe>
    </ng-template>

    @if (selectedWarehouse) {
        <pf-chip
            header-actions
            icon="location"
            pfColor="blue"
            (click)="openWarehouseDrawer()"
            class="warehouse-chip">
            {{ selectedWarehouse.label }}
        </pf-chip>
    }
    <pf-button header-actions buttonType="action" (click)="openUserDrawer()">
        <pf-icon iconType="user"></pf-icon>
    </pf-button>

    <div id="cpw-header-toolbar" header-bottom></div>
</pf-app-header>
